
import { defineComponent } from "vue";

export default defineComponent({
  name: "CaptureTwitter",
  created: function() {
    console.log(this.$route)
  }
})
